import { ModeTypes } from './types';
export class Modes {
    modeNumber;
    appWSM2021Modes = [
        ModeTypes.wsm2021easy,
        ModeTypes.wsm2021medium,
        ModeTypes.wsm2021hard
    ];
    trainingModes = [
        ModeTypes.taskTraining,
        ModeTypes.taskTrainingTrainer
    ];
    trainingWithTrainerMode = [
        ModeTypes.taskTrainingTrainer
    ];
    tutorialModes = [
        ModeTypes.tutorial,
        ModeTypes.tutorialFromTrainingHall
    ];
    isExternalApp = false;
    constructor() {
        console.log('vytvarame modes');
    }
    get mode() {
        console.log('get mode ', this.modeNumber);
        return this.modeNumber;
    }
    set mode(modeNumber) {
        this.modeNumber = modeNumber;
        console.log('set mode ', this.modeNumber, modeNumber);
    }
    isModeByParam(modeNumber) {
        return this.modeNumber === modeNumber;
    }
    isAppWSM2021() {
        return this.appWSM2021Modes.includes(this.modeNumber);
    }
    isTrainingMode() {
        return this.trainingModes.includes(this.modeNumber);
    }
    isTrainingWithTrainerMode() {
        return this.trainingWithTrainerMode.includes(this.modeNumber);
    }
    isTutorial(onlyFirstTutorial = false) {
        if (onlyFirstTutorial)
            return this.isModeByParam(ModeTypes.tutorial);
        return this.tutorialModes.includes(this.modeNumber);
    }
    isDailyLeague() {
        return this.isModeByParam(ModeTypes.dailyLeague);
    }
    isBossCompetition() {
        return this.isModeByParam(ModeTypes.bossCompetition);
    }
    isEventBossFight() {
        return this.isModeByParam(ModeTypes.eventBossFight);
    }
    isTournament() {
        return this.isModeByParam(ModeTypes.tournament);
    }
}
export const modes = new Modes();
//# sourceMappingURL=Modes.js.map